import React, { ReactElement, useState } from "react";
import DropdownOption from "./dropdownOption";

type State = string | number;
type OnButtonValueChange = (name: string, value: State) => void;

const DropdownRadioButton = ({
	children,
	name,
	title,
	placeholder,
	emptyValue,
	onChange,
	isOpen = false,
	onClick,
	value,
	close,
}: {
	children: ReactElement[];
	name: string;
	title: string;
	placeholder: string;
	emptyValue: State;
	onChange: OnButtonValueChange;
	isOpen?: boolean;
	onClick?;
	value?: any;
	close?: Function;
}) => {
	const [state, setState] = useState(value || emptyValue);

	const updateState = (active: boolean, value) => {
		setState(value);
		onChange(name, value);
		close();
	};

	const getSelectedValuesLabel = (): string => {
		let title = placeholder;
		for (let child of children) {
			const { value, title } = child.props;

			if (value === state) {
				return title;
			}
		}

		return title;
	};

	return (
		<div className={`filterAttribute ${isOpen ? "open" : "closed"} ${value == "any" ? "" : "active"}`}>
			<div className="filterValue" onClick={onClick}>
				{getSelectedValuesLabel()}
			</div>
			<div className="filterOptions">
				<h6>{title}</h6>
				{React.Children.map(children, (child: ReactElement, key) => (
					<DropdownOption
						{...child.props}
						active={state === child.props.value}
						key={key}
						onStateChange={updateState}
					/>
				))}
			</div>
		</div>
	);
};

export default DropdownRadioButton;
